import React, { useEffect, useRef, useState } from "react";
import mapIcon from "../../assets/marker.png";
import {
  acresToSquareKilometers,
  squareKilometersToAcres,
} from "../../ReusableFunctions/reusableFunctions";
import dateFormat from "dateformat";
import { getDronePilots } from "../../apis/dronePilots";
import { getDSPDrones } from "../../apis/drones";
import Loading from "../../ReusableFunctions/Loader";
import {
  AEROMEGH_SERVICES,
  DISCOUNT_TYPES,
  SERVICE_TYPES,
  STATUS,
  PRICE_BY_TYPES
} from "../../appConstants";
import Popup from "../../ReusableFunctions/Popup";
import SelectComponent from "../../ReusableComponents/SelectComponent";
import {
  applyDiscount,
  quickRequestUpdateAPI,
  updateRequest,
} from "../../apis/requests";
import ReschduleRequestPopup from "./ReschedulePopup";
import RequestDiscount from "./RequestDiscount";
import RequestCancelPopup from "./RequestCancelPopup";
import LoaderComponent from "../../ReusableComponents/LoaderComponent";
import OnHoldPopup from "./OnHoldPopup";
import OnCompletePopup from "./OnCompletePopup";

const RequestDetailsSection = React.forwardRef(({
  isLoading,
  request,
  sprayingRequest,
  setSprayingRequest,
  popupState,
  setPopupState,
  onRequestUpdate,
  requestInvoiceRef,
  onResetStatus,
}, ref) => {
  const [dronePilots, setDronePilots] = useState([]);
  const [assignedLocationsDronePilots, setAssignedLocationsDronePilots] =
    useState([]);
  const [drones, setDrones] = useState([]);
  const [selectedDroneUIN, setSelectedDroneUIN] = useState(null);
  const [droneType, setDroneType] = useState(null);
  const [isInputEditable, setisInputEditable] = useState(false);
  const [isEditingPilot, setIsEditingPilot] = useState(false);
  const [isEditingDroneUIN, setIsEditingDroneUIN] = useState(false);
  const [tempPilot, setTempPilot] = useState(null);
  const [tempDroneUIN, setTempDroneUIN] = useState(null);
  const [isShowAllPilots, setIsShowAllPiltos] = useState(
    sprayingRequest?.drone_pilot ? true : false
  );
  const [isDiscountChanged, setIsDiscountChanged] = useState(false);
  const [appliedDiscount, setAppliedDiscount] = useState(0);

  const discountApply = () => {
    return new Promise((resolve, reject) => {
      applyDiscount({ id: sprayingRequest.id, dsp_discount: appliedDiscount })
        .then((res) => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  };

  useEffect(() => {
    Loading.set(true);
    setIsEditingPilot(false);
    setIsEditingDroneUIN(false);
    setSelectedDroneUIN(null);
    setDroneType(null);
    setSprayingRequest({
      ...request,
      service_completed_area:
        request?.service_completed_area === 0 ||
        request?.service_completed_area === null
          ? ""
          : request?.price_by == "acre"
          ? squareKilometersToAcres(request?.service_completed_area).toFixed(2)
          : request?.service_completed_area,
    });
    getDronePilots()
      .then((res) => {
        setDronePilots(res.dronePilots.filter((d) => d.is_active));
        setAssignedLocationsDronePilots(
          res.dronePilots.filter(
            (d) => d.is_active && d.location_id === request?.location_id
          )
        );
      })
      .catch((err) => {
        console.log(err);
        Popup.alert("Error", err.errorMessage, "ERROR", () => {});
      });
    getDSPDrones()
      .then((res) => {
        const drone = res.find((d) => d.id === request?.drone_id);
        const drones = res?.filter((d) => d?.service_type === SERVICE_TYPES[0] || 'Spraying service');
        
        setDrones(drones);
        if (drone) {
          setSelectedDroneUIN(drone?.drone_uin);
          setDroneType(drone?.type);
        }
      })
      .catch((err) => {
        console.log(err);
        Popup.alert("Error", err, "ERROR", () => {});
      });
    Loading.set(false);
  }, [request]);

  useEffect(() => {
    const isEditableStatus = [
      STATUS.ACCEPTED,
      STATUS.RESCHEDULED,
      STATUS.OUT_FOR_SERVICE,
      STATUS.PLACED,
    ].includes(sprayingRequest.status);
    if (sprayingRequest.status === STATUS.OUT_FOR_SERVICE) {
      setSprayingRequest((prev) => ({ ...prev, time: new Date() }));
    }
    setisInputEditable(
      isEditableStatus || request?.status === STATUS.RESCHEDULED
    );
  }, [sprayingRequest.status]);

  const SingleField = ({ label, value, isEditable }) => {
    return (
      <div className="flex items-center">
        <span className="font-manrope font-[500] text-[15px] custom-lg:text-[16px]  text-[#3B3B3B] mr-1">
          {label} :
        </span>
        <span className="flex items-center">
          {value}
          {isEditable && (
            <span className="ml-2 text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline  ">
              Change
            </span>
          )}
        </span>
      </div>
    );
  };

  const quickRequestUpdateFunc = async (
    status,
    pilotId,
    requestId,
    droneId,
    note
  ) => {
    try {
      let { updatedRequest } = await quickRequestUpdateAPI(
        status,
        pilotId,
        requestId,
        droneId,
        note
      );
      return updatedRequest;
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    const linkedDroneToPilot = dronePilots.find(
      (p) => p.id === sprayingRequest?.drrone_pilot
    )?.assigned_drone;
    if (linkedDroneToPilot) handleDroneSelection({ value: linkedDroneToPilot });
    setSprayingRequest((prev) => ({
      ...prev,
      drone_pilot: sprayingRequest?.drone_pilot,
    }));
  }, [sprayingRequest.drone_pilot]);

  const handleDroneSelection = (e) => {
    const value = e.value;
    const selectedDrone = drones.find((drone) => drone.drone_uin === value);
    if (selectedDrone) {
      setDroneType(selectedDrone.type);
      setSelectedDroneUIN(value);
      setSprayingRequest((prev) => ({
        ...prev,
        drone_id: selectedDrone.id,
      }));
    } else {
      setSelectedDroneUIN(null);
      setDroneType(null);
    }
  };

  useEffect(() => {
    if (tempPilot) {
      const selectedPilot = dronePilots.find((p) => p.id === tempPilot);
      if (selectedPilot) {
        const assignedDrone = drones.find(
          (d) => d.id === selectedPilot.drone_id
        );
        if (assignedDrone) {
          setSelectedDroneUIN(assignedDrone.drone_uin);
          setDroneType(assignedDrone.type);
          setTempDroneUIN(assignedDrone.drone_uin);
        }
      }
    }
  }, [tempPilot]);

let assigned_drone=tempDroneUIN?drones.find((d)=>d.drone_uin===tempDroneUIN)?.id:null
  return (
    <>
      <ReschduleRequestPopup
        open={popupState?.reschedule}
        onClose={() => {
          setPopupState((prev) => ({
            ...prev,
            reschedule: false,
          }));
          onResetStatus()
        }}
        date={new Date(sprayingRequest?.time)}
        onRequestUpdate={async (selectedDate, reschduleReason) => {
          try {
            Loading.set(true);
            const invoice = ref.current?.getInvoice();
            let data = await updateRequest(
              {
                ...sprayingRequest,
                ...invoice,
                applied_coupons: invoice.applied_coupons,
                applied_discounts: [
                  {
                    discount_type: "dsp_request_discount",
                    discount: Number(invoice.total_dsp_discount_percentage),
                    discounted_amount: invoice.total_discounted_amount_via_dsp,
                  },
                ],
                status: STATUS.RESCHEDULED,
                time: new Date(selectedDate),
                note: reschduleReason,
              },
              AEROMEGH_SERVICES.SPRAYING
            );
            setPopupState((prev) => ({
              ...prev,
              reschedule: false,
            }));
            onRequestUpdate(data.updatedRequest, STATUS.RESCHEDULED);
          } catch (err) {
            Loading.set(false);
            console.log("err", err);
            Popup.alert(
              "ERROR",
              err || "Something went wrong while rescheduling request",
              "ERROR"
            );
          }
        }}
      />
      <RequestCancelPopup
        open={popupState.cancel}
        onClose={() => { setPopupState((prev) => ({ ...prev, cancel: false }))
          onResetStatus()
        }
        }
        onRequestUpdate={async (cancelReason) => {
          try {
            Loading.set(true);
            let data = await updateRequest(
              {
                ...sprayingRequest,
                status: STATUS.CANCELLED,
                note: cancelReason,
              },
              AEROMEGH_SERVICES.SPRAYING
            );

            setPopupState((prev) => ({
              ...prev,
              cancel: false,
            }));
            onRequestUpdate(data.updatedRequest, STATUS.CANCELLED);
          } catch (err) {
            Loading.set(false);
            console.log("err", err);
            Popup.alert(
              "ERROR",
              err || "Something went wrong while canceling request",
              "ERROR"
            );
          }
        }}
      />

    <OnCompletePopup
      open={popupState?.complete}
      onClose={()=>{
        setPopupState((prevState)=>({
          ...prevState,
          complete:false,
        }))
        onResetStatus()
      }}
      onRequestSubmit={async (type, areaValue, submitButtonType) => {
        // if(request.price_by === "acre" && type === "tank") {
        //   request.field_area = squareKilometersToAcres(request.field_area);
        // }
        // if(request.price_by === "tank" && type === "acre") {
        //   request.field_area = acresToSquareKilometers(request.field_area);
        // } 
        request.price_by = type;
        request.service_completed_area = request.price_by == PRICE_BY_TYPES.ACRE ? acresToSquareKilometers(areaValue) : areaValue
        console.log("on complete click ",request.service_completed_area);
        if(submitButtonType === "submit") {
          try {
            Loading.set(true);
            const invoice = requestInvoiceRef.current?.getInvoice();
            let data = await updateRequest(
              {
                ...request,
                ...invoice,
                applied_coupons: invoice.applied_coupons,
                applied_discounts: [
                  {
                    discount_type: "dsp_request_discount",
                    discount: Number(invoice.total_dsp_discount_percentage),
                    discounted_amount: invoice.total_discounted_amount_via_dsp,
                  },
                ],
                status: STATUS.COMPLETED,
              },
              AEROMEGH_SERVICES.SPRAYING
            );
            onRequestUpdate(data.updatedRequest, STATUS.COMPLETED);
          } catch (err) {
            Loading.set(false);
            console.log("err", err);
            Popup.alert(
              "ERROR",
              err || "Something went wrong while paid request",
              "ERROR"
            );
          }
        }

        setPopupState((prev) => ({
          ...prev,
          complete: false,
        }));
      }}
    />

    <OnHoldPopup
      open={popupState?.hold}
      onClose={()=>{
        setPopupState((prevState)=>({
          ...prevState,
          hold:false,
        }))
        onResetStatus()
      }}
      onRequestUpdate={async(onHoldReason)=>{
      try {
        const invoice = ref.current?.getInvoice();
        Loading.set(true);
        let data = await updateRequest(
          {
            ...sprayingRequest,
            ...invoice,
            applied_coupons: invoice.applied_coupons,
            applied_discounts: [
              {
                discount_type: "dsp_request_discount",
                discount: Number(invoice.total_dsp_discount_percentage),
                discounted_amount: invoice.total_discounted_amount_via_dsp,
              },
            ],
            status: STATUS.HOLD,
            note: onHoldReason,
          },
          AEROMEGH_SERVICES.SPRAYING
        );

        setPopupState((prev) => ({
          ...prev,
          hold: false,
        }));
        onRequestUpdate(data.updatedRequest, STATUS.HOLD);
      } catch (err) {
        Loading.set(false);
        console.log("err", err);
        Popup.alert(
          "ERROR",
          err || "Something went wrong while put request on hold",
          "ERROR"
        );
      }
      }}
    />

      {isLoading ? (
        <div className="w-[75%]">
          <LoaderComponent width={"3%"} height={"3%"} />
        </div>
      ) : (
        <div
          style={{
            fontFamily: "Manrope !important",
          }}
          className="font-manrope [&>*]:font-inherit [&>*]:text-inherit w-[80%] max-h-full overflow-y-scroll border-r border-r-[#D9D9D9] font-manrope"
        >
          <div className="bg-[#D9D9D9]/30 px-10 py-3 text-sm text-[#3B3B3B] items-center gap-[0.6rem] flex">
            <img src={mapIcon} width={16} height={16} alt={"map-icon"}></img>
            <span className="">{request?.field_address}</span>
          </div>
          <div className="w-full px-4 py-4 custom-lg:px-10">
            {/* customer details section  */}
            <div className="w-full flex justify-between mb-5 ">
              <div className="flex flex-col">
                <div className="flex gap-3 items-center">
                <span className="text-[17px] text-[#1E1E1E] font-[600] font-manrope ">
                  {request?.user_name}
                </span>
                {/* {request?.isRequestFromBES && (
                 <div className="w-[50px] flex justify-center border border-[#0F5EFF] rounded-md items-center bg-[#0F5EFF]/15">
                  <span className="font-manrope text-[14px] text-[#0F5EFF] font-[550]">BES</span>
                 </div>
                )} */}
                </div>
                <span className="text-[14px] font-manrope text-[#3B3B3B] font-[500]">
                  Contact No. {request?.user_phone}
                </span>
              </div>
              <span className="text-[14px] font-manrope text-[#3B3B3B] font-[500">
                Request No.{" "}
                <span className="font-[600]">#{request?.req_number}</span>{" "}
              </span>
            </div>
            <div className=" h-[5px]  border-b border-b-[#BFC8D9]"></div>
            {/* service details  */}
            <div className="py-5">
              <h4 className="font-manrope font-[700] text-[18px] text-[#1E1E1E]">
                Service Details{" "}
              </h4>
              <div className="grid grid-cols-2  gap-x-[10px]  gap-y-3 w-[100%] my-3">
                <SingleField label={"Crop"} value={request?.crop_name || "-"} />
                <SingleField
                label={"Requested Area"}
                value={
                  request?.field_area
                    ? `${request.price_by === "acre" 
                        ? squareKilometersToAcres(request.field_area) 
                        : request.field_area} ${request.price_by === "acre" ? "Acre" : "Tank"}`
                    : "-"
                }
              />
              <SingleField
                label={"AgroChemical"}
                value={request?.pesticides || "-"}
              />
              <SingleField
                label={"Completed Area"}
                value={
                  request?.service_completed_area
                    ? `${request.price_by === "acre" 
                        ? squareKilometersToAcres(request.service_completed_area) 
                        : request.service_completed_area} ${request.price_by === "acre" ? "Acre" : "Tank"}`
                    : "-"
                }
              />
                <SingleField
                  label={"Received On"}
                  value={
                    request?.date_created
                      ? dateFormat(request.date_created, "dd/mm/yyyy")
                      : "-"
                  }
                />
              </div>
            </div>
            <div className=" h-[5px] border-b border-b-[#BFC8D9]"></div>
            {/* resource Details  */}
            <div className="py-5">
              <h4 className="font-manrope font-[700] text-[18px] text-[#1E1E1E]">
                Resource Details{" "}
              </h4>
              <div className="grid grid-cols-2 gap-x-[10px]  gap-y-3 w-[100%] my-3">
                <div className="flex flex-col"> 
                  <SingleField
                    label={"Assigned Pilot"}
                    value={
                      isEditingPilot ? (
                        <div className="flex flex-col ">
                          <div className="-mt-3 mb-1 flex ">
                            <input
                              style={{ margin: "0 10px", height: "18px" }}
                              checked={isShowAllPilots}
                              onChange={(e) =>
                                setIsShowAllPiltos(e.target.checked)
                              }
                              value={isShowAllPilots}
                              type={"checkbox"} 
                              className="input-checkbox"
                            />
                            <div
                              style={{
                                color: "rgba(59, 59, 59, 0.8)",
                                fontSize: "13px",
                              }}
                            >
                              Show All
                            </div>
                          </div>
                          <div className="flex gap-[0.5rem] custom-lg:gap-4  items-center">
                            <SelectComponent
                              controlStyle={{
                                width: "135px",
                                background: "#F3F3F3",
                                border: "1px solid #D9D9D9",
                                borderRadius: "4px",
                              }}
                              value={
                                tempPilot
                                  ? {
                                      value: tempPilot,
                                      label: dronePilots.find(
                                        (p) => p.id === tempPilot
                                      )?.first_name,
                                    }
                                  : ""
                              }
                              onChange={(selectedPilot) => {
                                setTempPilot(selectedPilot.value);
                              }}
                              list={(isShowAllPilots
                                ? dronePilots
                                : assignedLocationsDronePilots
                              ).map((el) => ({
                                value: el.id,
                                label: el.first_name,
                              }))}
                              isSearchable={true}
                            />
                            <div className="flex gap-[8px] custom-lg:gap-[20px]">
                            <span
                              className="text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline"
                              onClick={async () => {
                                if(!tempPilot){
                                  return;
                                }
                                try {
                                  Loading.set(true);
                                  let updatedRequest =
                                    await quickRequestUpdateFunc(
                                      undefined,
                                      tempPilot,
                                      sprayingRequest?.id,
                                      assigned_drone?assigned_drone:undefined,
                                      undefined,
                                      undefined
                                    );
                                    console.log("updated Request",updatedRequest)
                                  setSprayingRequest((prev) => ({
                                    ...prev,
                                    drone_id:updatedRequest?.drone_id??null,
                                    drone_pilot: updatedRequest?.drone_pilot,
                                  }));
                                  Popup.alert(
                                    "SUCCESS",
                                    "Drone pilot chnaged successfully !",
                                    "SUCCESS"
                                  );
                                } catch (err) {
                                  Popup.alert("Error", err, "ERROR");
                                } finally {
                                  Loading.set(false);
                                }
                                setIsEditingPilot(false);
                                setIsEditingDroneUIN(false);
                              }}
                            >
                              Assign
                            </span>
                            <span
                              className="text-[#1E1E1E] font-manrope text-[15px] cursor-pointer font-[600] underline"
                              onClick={() => {
                                setTempPilot(null);
                                setTempDroneUIN(
                                  drones.find(
                                    (drone) =>
                                      drone.id === sprayingRequest?.drone_id
                                  )?.drone_uin
                                );
                                let drone_uin=drones.find(
                                  (drone) =>
                                    drone.id === sprayingRequest?.drone_id
                                )?.drone_uin
                                setSelectedDroneUIN(drone_uin);
                                setIsEditingPilot(false);
                                setDroneType(
                                  drones.find(
                                    (d) => d.drone_uin === drone_uin
                                  )?.type
                                );
                              }}
                            >
                              Cancel
                            </span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="flex gap-4">
                          <span className="font-manrope font-[600] text-[16px] text-[#1E1E1E] ">
                            {dronePilots.find(
                              (p) => p.id === sprayingRequest?.drone_pilot
                            )?.first_name || "-"}
                          </span>
                          {![
                            STATUS.PLACED,
                            STATUS.PAID,
                            STATUS.COMPLETED,
                            STATUS.CANCELLED,
                          ].includes(request?.status) &&
                            request?.user != null &&
                            request?.user?.id != null && (
                              <span
                                className="text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline"
                                onClick={() => {
                                  setTempPilot(sprayingRequest?.drone_pilot);
                                  setIsEditingPilot(true);
                                }}
                              >
                                Change
                              </span>
                            )}
                        </div>
                      )
                    }
                  />
                </div>

                <SingleField
                  label={"Assigned Drone "}
                  value={
                    isEditingDroneUIN ? (
                      <div className="flex gap-[0.5rem] custom-lg:gap-4 items-center">
                        <SelectComponent
                          controlStyle={{
                            width: "135px",
                            background: "#F3F3F3",
                            border: "1px solid #D9D9D9",
                            borderRadius: "4px",
                          }}
                          value={
                            tempDroneUIN
                              ? {
                                  value: tempDroneUIN,
                                  label: tempDroneUIN,
                                }
                              : ""
                          }
                          onChange={(drone) => {
                            setTempDroneUIN(drone?.value);
                            setDroneType(
                              drones.find((d) => d.drone_uin === drone?.value)
                                ?.type
                            );
                          }}
                          list={drones.map((el) => ({
                            value: el.drone_uin,
                            label: el.drone_uin,
                          }))}
                          isSearchable={true}
                        />
                        <span
                          className="text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline "
                          onClick={async () => {
                            if(!tempDroneUIN){
                              return;
                            }
                            try {
                              Loading.set(true);
                              const selectedDrone = drones.find(
                                (drone) => drone.drone_uin === tempDroneUIN
                              );
                              let updatedRequest = await quickRequestUpdateFunc(
                                undefined,
                                undefined,
                                sprayingRequest?.id,
                                selectedDrone?.id,
                                undefined
                              );
                              setSprayingRequest((prev) => ({
                                ...prev,
                                drone_id: selectedDrone?.id,
                              }));
                              setSelectedDroneUIN(selectedDrone.drone_uin);
                              setDroneType(selectedDrone?.type);
                              Popup.alert(
                                "SUCCESS",
                                "Drone has chnaged successfully !",
                                "SUCCESS"
                              );
                            } catch (err) {
                              Popup.alert("Error", err, "ERROR");
                            } finally {
                              Loading.set(false);
                            }
                            setIsEditingDroneUIN(false);
                          }}
                        >
                          Assign
                        </span>
                        <span
                          className="text-[#1E1E1E] font-manrope text-[15px] cursor-pointer font-[600] underline"
                          onClick={() => {
                            setTempDroneUIN(
                              drones.find(
                                (drone) =>
                                  drone.id === sprayingRequest?.drone_id
                              )?.drone_uin
                            );
                            let drone_uin= drones.find(
                              (drone) =>
                                drone.id === sprayingRequest?.drone_id
                            )?.drone_uin
                            setSelectedDroneUIN(drone_uin);
                            setIsEditingDroneUIN(false);
                            setDroneType(
                              drones.find(
                                (d) => d.drone_uin === drone_uin
                              )?.type
                            );
                          }}
                        >
                          Cancel
                        </span>
                      </div>
                    ) : (
                      <div className="flex gap-4">
                        <span className="font-manrope font-[600] text-[16px] text-[#1E1E1E] ">
                          {selectedDroneUIN || "-"}
                        </span>
                        {![
                            STATUS.PLACED,
                            STATUS.PAID,
                            STATUS.COMPLETED,
                            STATUS.CANCELLED,
                        ].includes(request?.status) &&
                          request?.user != null &&
                          request?.user?.id != null && (
                            <span
                              className="text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline"
                              onClick={() => {
                                setTempDroneUIN(selectedDroneUIN);
                                setIsEditingDroneUIN(true);
                              }}
                            >
                              Change
                            </span>
                          )}
                      </div>
                    )
                  }
                />

                <SingleField
                  label={"Assinged Drone Type"}
                  value={droneType || "-"}
                />
                <SingleField
                  label={"Schedule on"}
                  value={dateFormat(request?.time, "dd/mm/yyyy") || "-"}
                />
              </div>
            </div>
            <div className=" h-[5px] border-b border-b-[#BFC8D9]"></div>
            <div className="w-[500px]"></div>
            <div style={{ width: "100%" }}>
              {
                <RequestDiscount
                  ref={ref}
                  oldRequest={request || {}}
                  hideToggle={sprayingRequest?.status === STATUS.PLACED}
                  request={{
                    ...sprayingRequest,
                    service_completed_area:
                      sprayingRequest.service_completed_area &&
                      sprayingRequest.price_by === "acre"
                        ? acresToSquareKilometers(
                            Number(sprayingRequest.service_completed_area)
                          )
                        : Number(sprayingRequest.service_completed_area),
                  }}
                  updateRequest={async () => {
                    try {
                      Loading.set(true);
                      const invoice = ref.current?.getInvoice();
                      if (isDiscountChanged) {
                        await discountApply();
                      }
                      const data = await updateRequest(
                        {
                          ...sprayingRequest,
                          ...invoice,
                          status:sprayingRequest?.status===STATUS.COMPLETED?undefined:sprayingRequest.status,
                          applied_coupons: invoice.applied_coupons,
                          service_completed_area:
                          sprayingRequest.service_completed_area &&
                          sprayingRequest.price_by === "acre"
                            ? acresToSquareKilometers(
                                Number(sprayingRequest.service_completed_area)
                              )
                            : Number(sprayingRequest.service_completed_area),
                          applied_discounts: [
                            {
                              discount_type: "dsp_request_discount",
                              discount: Number(
                                invoice.total_dsp_discount_percentage
                              ),
                              discounted_amount:
                                invoice.total_discounted_amount_via_dsp,
                            },
                          ],
                        },
                        AEROMEGH_SERVICES.SPRAYING
                      );

                      Popup.alert(
                        "Discount",
                        "Discount changed successfully !",
                        "SUCCESS"
                      );
                    } catch (err) {
                      Popup.alert(
                        "ERROR",
                        err || "Something went wrong while updating discount",
                        "ERROR"
                      );
                    } finally {
                      Loading.set(false);
                    }
                  }}
                  changeValue={(value) => {
                    let discountData =
                      request?.invoice?.applied_discounts?.find(
                        (ad) =>
                          ad.discount_type ===
                          DISCOUNT_TYPES.DSP_REQUEST_DISCOUNT
                      );
                    if (discountData) {
                      if (Number(discountData.discount) == Number(value))
                        setIsDiscountChanged(false);
                      else setIsDiscountChanged(true);
                      // setNoValueChanged(false);
                    } else if (value > 0) {
                      // setNoValueChanged(false);
                      setIsDiscountChanged(true);
                    } else {
                      // setNoValueChanged(true);
                      setIsDiscountChanged(false);
                    }
                    setAppliedDiscount(Number(value));
                  }}
                />
              }
            </div>
          </div>
        </div>
      )}
    </>
  );
});
export default RequestDetailsSection;
